

















import { computed, defineComponent, onBeforeUnmount, PropType, ref } from "@vue/composition-api";
import Vue from "vue";
import useBreakPoints from "@/hooks/useBreakPoints";
import { getElement } from "@/lib/elementHelpers";
import emitter from "@/lib/emitter";
import { removeLastCharacter } from "@/lib/textHelpers";
import { EmojiPickerProps } from "@/types";
import { EVENTS, INPUT_PROPS } from "@/const";
import BaseInputTextarea from "@/components/BaseInputTextarea";

export default defineComponent({
  name: "RichTextarea",
  components: { BaseInputTextarea },
  props: {
    transparent: { type: Boolean, default: false },
    allowEmoji: { type: Boolean, default: true },
    ...INPUT_PROPS,
    rowHeight: { type: Number, default: 56 },
    rows: { type: Number, default: 2 },
    maxRows: { type: Number, default: 5 },
    autoGrow: { type: Boolean, default: false },
    disabled: { default: false },
    fieldClass: { type: [String, Object, Array] },
    submit: {
      type: String as PropType<"" | "enter" | "shiftEnter">,
      default: "",
      validator: (value: string) => ["", "enter", "shiftEnter"].includes(value),
    },
  },
  setup(props, { emit, listeners }) {
    const { portraitUp } = useBreakPoints();
    const baseInput = ref<Vue | undefined>();
    const root = ref<Vue | undefined>();
    const showEmoji = ref(false);

    const _allowEmoji = computed(() => props.allowEmoji && portraitUp.value);
    const emojiIcon = computed(() => (showEmoji.value ? "sci-keyboard-outline" : "sci-emoji-happy-outline"));
    const filteredListeners = computed(() => {
      const { ["click:appendIcon"]: f, ["click:secondPrependIcon"]: s, ...l } = listeners;
      return l;
    });

    const inputEmoji = (v: string) => emit("input", props.value + v);

    const onShowEmoji = () => {
      showEmoji.value = !showEmoji.value;
      showEmoji.value &&
        emitter.emit<EmojiPickerProps>(EVENTS.EMOJI_PICKER_SHOW, {
          show: true,
          anchorElement: getElement<HTMLInputElement>(root.value),
          onInput: inputEmoji,
          onRemove: () => props.value && emit("input", removeLastCharacter(props.value)),
          onClose: () => (showEmoji.value = false),
        });
      if (!showEmoji.value) getElement<HTMLInputElement>(baseInput.value?.$refs.textareaElement).focus();
    };

    onBeforeUnmount(() => emitter.emit<EmojiPickerProps>(EVENTS.EMOJI_PICKER_SHOW, { show: false }));

    return {
      root,
      baseInput,
      showEmoji,
      emojiIcon,
      _allowEmoji,
      filteredListeners,
      onShowEmoji,
    };
  },
});
